import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Apollo } from 'apollo-angular';

import { FetchFilterDataMethods } from './fetch-filter-data-methods';

export enum AuFilterOptionsListName {
	relatedToBuildingOrganizations = 'relatedToBuildingOrganizations',
	predictiveMaintenance = 'predictiveMaintenance',
	comfortStatuses = 'comfortStatuses',
	buildingKpiStatuses = 'buildingStatuses',
	organizations = 'organizations',
	techStatuses = 'techStatuses',
	buildings = 'buildings',
	tenants = 'tenants',
	floors = 'floors',
	vendors = 'vendors',
	accessActivityStatuses = 'accessActivityStatus',
}

@Injectable({
	providedIn: 'root',
})
export class SelectableOptionsService extends FetchFilterDataMethods {
	constructor(
		public apollo: Apollo,
		public store$: Store<any>
	) {
		super(apollo, store$);
	}

	getSelectableOptions(optionsName: AuFilterOptionsListName): Observable<any[]> {
		const methodToNameMap = {
			[AuFilterOptionsListName.organizations]: () => this.getOrganizations(),
			[AuFilterOptionsListName.relatedToBuildingOrganizations]: () =>
				this.getOrganizationsRelatedToBuilding(),
			[AuFilterOptionsListName.buildings]: () => this.getUserProperties(),
			[AuFilterOptionsListName.tenants]: () => this.getTenants(),
			[AuFilterOptionsListName.comfortStatuses]: () =>
				this.getComfortStatusFilterOptions(),
			[AuFilterOptionsListName.buildingKpiStatuses]: () => this.getBuildingKpiStatuses(),
			[AuFilterOptionsListName.floors]: () => this.getBuildingFloors(),
			[AuFilterOptionsListName.techStatuses]: () => this.getSystemRunOptions(),
			[AuFilterOptionsListName.predictiveMaintenance]: () =>
				this.getPredictiveMaintenanceFilterOptions(),
			[AuFilterOptionsListName.vendors]: () => this.getVendors(),
			[AuFilterOptionsListName.accessActivityStatuses]: () => this.getAccessStatuses(),
		};

		if (methodToNameMap[optionsName]) {
			return methodToNameMap[optionsName]();
		}

		throw new Error(
			`FilterService doesn't support ${optionsName} data. Check your filter config or add new functionality here`
		);
	}
}
